
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.917 8A6.002 6.002 0 010 7a6 6 0 0111.917-1H22v2h-2v4h-2V8h-2v4h-2V8h-2.083zM6 11a4 4 0 100-8 4 4 0 000 8z","fill":"#FAAD14"}})])
          )
        }
      }
    